export default "__VITE_ASSET__BbJM4UlJ__"